function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Lunch/Green/Bold/Alt");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Icon/Lunch/Green/Bold/Alt",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.000000, 2.000000)",
  fill: "#155C28",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  transform: "translate(28.537761, 28.537999) rotate(-45.000000) translate(-28.537761, -28.537999) ",
  points: "26.412761 24.6991862 30.662761 24.6991862 30.662761 32.3768112 26.412761 32.3768112"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.252375,2.747625 C30.4225628,1.91806338 29.0774372,1.91806338 28.247625,2.747625 L17,13.99525 L15.004625,11.99775 L16.68975,10.31475 C16.8895886,10.1154159 17.0018993,9.84475793 17.0018993,9.5625 C17.0018993,9.28024207 16.8895886,9.00958406 16.68975,8.81025 L8.18975,0.31025 C7.77429379,-0.105206188 7.10070621,-0.105206181 6.68525002,0.310250016 C6.26979382,0.725706213 6.26979381,1.39929379 6.68525,1.81475 L13.372625,8.5 L11.6875,10.185125 L5.00225,3.49775 C4.58679379,3.08229381 3.91320621,3.08229382 3.49775002,3.49775002 C3.08229382,3.91320621 3.08229381,4.58679379 3.49775,5.00225 L10.185125,11.6875 L8.5,13.372625 L1.81475,6.68525 C1.39929379,6.26979381 0.725706213,6.26979382 0.310250016,6.68525002 C-0.105206181,7.10070621 -0.105206188,7.77429379 0.31025,8.18975 L8.81025,16.68975 C9.00958406,16.8895886 9.28024207,17.0018993 9.5625,17.0018993 C9.84475793,17.0018993 10.1154159,16.8895886 10.31475,16.68975 L11.99775,15.004625 L13.99525,17 L1.24525,29.75 L4.25,32.75475 L12.75,24.25475 L15.5635,27.06825 C16.3933122,27.8978116 17.7384378,27.8978116 18.56825,27.06825 L31.252375,14.38625 C32.796703,12.8433769 33.6644198,10.7499185 33.6644198,8.5669375 C33.6644198,6.38395646 32.796703,4.29049808 31.252375,2.747625 Z",
  id: "Path"
})));

var SvgLunchActiveIcon = function SvgLunchActiveIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLunchActiveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lunch-active-icon.a429d81e.svg";
export { ForwardRef as ReactComponent };